// node:fs のブラウザ代替。lib/*.mjs が使う同期 API のみを VFS へ委譲する。
// readFileSync は encoding 引数を尊重する（enc あり→string / なし→Buffer 互換）。
import { vfs } from '../vfs.mjs';
import { Buffer as VnBuffer } from './buffer.mjs';

const dec = new TextDecoder('utf-8');

export function existsSync(p) {
    return vfs.exists(p);
}

export function readFileSync(p, options) {
    const encoding = typeof options === 'string' ? options : options?.encoding;
    const v = vfs.read(p);
    if (encoding) {
        if (typeof v === 'string') return v;
        return dec.decode(v);
    }
    // encoding 無し＝Buffer 相当を期待。素の Uint8Array だと toString('base64') が
    // カンマ結合の数値列になる（Meshy への data URI が壊れる）ため VnBuffer で返す。
    if (typeof v === 'string') return VnBuffer.from(v);
    return VnBuffer.from(v);
}

export function writeFileSync(p, data) {
    vfs.write(p, data);
}

export function mkdirSync(p) {
    vfs.mkdir(p);
    return undefined;
}

export function readdirSync(p, options) {
    // Node と同じく、不存在ディレクトリは空配列でなく ENOENT を投げる
    //（黙って [] を返すと existsSync ガードの無い呼び出しで挙動が食い違う）
    if (!vfs.isDirectory(p)) {
        const err = new Error(`ENOENT: no such directory, scandir '${p}'`); err.code = 'ENOENT'; throw err;
    }
    return vfs.readdir(p, !!(options && options.withFileTypes));
}

export function unlinkSync(p) {
    vfs.rm(p, false);
}

export function rmSync(p, options) {
    vfs.rm(p, !!(options && options.recursive));
}

export function statSync(p) {
    const isDir = vfs.isDirectory(p);
    if (!isDir && !vfs.existsFile(p)) {
        const err = new Error(`ENOENT: ${p}`); err.code = 'ENOENT'; throw err;
    }
    return { isDirectory: () => isDir, isFile: () => !isDir };
}

export function readFile() {
    throw new Error('fs.readFile(async) はブラウザ版 VFS では未対応です（同期版を使用してください）。');
}

export default {
    unlinkSync,
    existsSync, readFileSync, writeFileSync, mkdirSync, readdirSync, rmSync, statSync,
};
